/**
 * ekimall-pdp-desc-images.js (v222b)
 * Description HTML embeds dozens of huge external JPEGs (img.pixer-kr.com),
 * often 950×5k–9k px. Mobile Safari hits network + decode limits → blue "?" icons.
 *
 * Harden:
 *  - referrerpolicy=no-referrer, decoding=async, loading=lazy
 *  - gate: keep first 2 with src; defer the rest via data-ekimall-src + IO
 *  - sequential queue (max 2 in flight)
 *  - one clean retry on error (no query-string pollution)
 * Note: images taller than ~4096px may still fail decode on some iPhones —
 * merchant must rehost resized copies to Shopify Files for a full fix.
 */
(function () {
  if (window.__ekimallPdpDescImages) return;
  window.__ekimallPdpDescImages = true;

  var SELECTOR = [
    '.ekimall-pdp-desc img',
    '#prd_html img',
    '.product-details .rte img',
    '.product-details .text-block.rte img',
    '.product-information .rte img'
  ].join(',');

  var MAX_INFLIGHT = 2;
  var KEEP_EAGER = 2;
  var queue = [];
  var inflight = 0;

  function setAttrs(img) {
    try { img.decoding = 'async'; } catch (e) {}
    try { img.loading = 'lazy'; } catch (e) {}
    try { img.referrerPolicy = 'no-referrer'; } catch (e) {}
    img.setAttribute('decoding', 'async');
    img.setAttribute('loading', 'lazy');
    img.setAttribute('referrerpolicy', 'no-referrer');
  }

  function cleanSrc(src) {
    if (!src) return src;
    return src
      .replace(/([?&])ekimall_retry=1(&)?/g, function (_, a, b) {
        if (a === '?' && b) return '?';
        if (a === '?' && !b) return '';
        return b ? a : '';
      })
      .replace(/[?&]$/, '');
  }

  function pump() {
    while (inflight < MAX_INFLIGHT && queue.length) {
      (function (img) {
        inflight++;
        var src = cleanSrc(
          img.getAttribute('data-ekimall-src') ||
            img.getAttribute('src') ||
            img.getAttribute('data-src') ||
            ''
        );
        if (!src || src.indexOf('data:') === 0) {
          inflight--;
          pump();
          return;
        }
        setAttrs(img);
        var finished = false;
        function done() {
          if (finished) return;
          finished = true;
          inflight--;
          pump();
        }
        img.addEventListener('load', done, { once: true });
        img.addEventListener(
          'error',
          function () {
            if (img.dataset.ekimallRetry === '1') {
              img.style.display = 'none';
              img.setAttribute('data-ekimall-broken', '1');
              var wrap = img.parentElement;
              if (wrap && wrap.tagName === 'DIV' && wrap.childElementCount === 1) {
                wrap.style.display = 'none';
              }
              done();
              return;
            }
            img.dataset.ekimallRetry = '1';
            setAttrs(img);
            img.removeAttribute('src');
            // force a fresh request with no-referrer already set
            img.src = src;
          },
          { once: true }
        );
        if (img.getAttribute('src') !== src) {
          img.setAttribute('data-ekimall-src', src);
          img.src = src;
        } else if (img.complete) {
          if (img.naturalWidth > 0) done();
          else {
            img.dataset.ekimallRetry = '1';
            img.removeAttribute('src');
            img.src = src;
          }
        }
      })(queue.shift());
    }
  }

  function harden(img, indexInGroup) {
    if (!img || img.dataset.ekimallDescHardened === '1') return;
    img.dataset.ekimallDescHardened = '1';
    setAttrs(img);

    var src = cleanSrc(
      img.getAttribute('src') ||
        img.getAttribute('data-src') ||
        img.getAttribute('data-lazy-src') ||
        ''
    );
    if (!src || src.indexOf('data:') === 0) return;

    // Defer most images so Safari does not open 30+ connections / decodes at once
    if (indexInGroup >= KEEP_EAGER) {
      img.setAttribute('data-ekimall-src', src);
      img.removeAttribute('src');
      img.removeAttribute('srcset');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              if (!en.isIntersecting) return;
              io.unobserve(img);
              queue.push(img);
              pump();
            });
          },
          { rootMargin: '300px 0px', threshold: 0.01 }
        );
        io.observe(img);
      } else {
        queue.push(img);
        pump();
      }
      return;
    }

    queue.push(img);
    pump();
  }

  function run(root) {
    var scope = root || document;
    var groups = [];
    var descRoots = scope.querySelectorAll
      ? scope.querySelectorAll('.ekimall-pdp-desc')
      : [];
    if (descRoots && descRoots.length) {
      for (var g = 0; g < descRoots.length; g++) groups.push(descRoots[g]);
    } else if (scope.querySelectorAll) {
      groups.push(scope);
    } else {
      groups.push(document);
    }
    for (var gi = 0; gi < groups.length; gi++) {
      var imgs = groups[gi].querySelectorAll
        ? groups[gi].querySelectorAll(SELECTOR)
        : [];
      // If group is document-wide fallback, still use SELECTOR once
      if (!imgs.length && groups[gi] === scope) {
        imgs = document.querySelectorAll(SELECTOR);
      }
      for (var i = 0; i < imgs.length; i++) harden(imgs[i], i);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) {
    run(e.target);
  });

  // Hide any description img that ends permanently broken (native lazy path too)
  document.addEventListener(
    'error',
    function (ev) {
      var t = ev.target;
      if (!t || t.tagName !== 'IMG') return;
      if (!t.closest || !t.closest('.ekimall-pdp-desc, #prd_html, .product-details .rte')) return;
      if (t.dataset.ekimallRetry === '1' && t.dataset.ekimallBroken !== '1') {
        t.dataset.ekimallBroken = '1';
        t.style.display = 'none';
        var wrap = t.parentElement;
        if (wrap && wrap.tagName === 'DIV' && wrap.childElementCount === 1) wrap.style.display = 'none';
      }
    },
    true
  );

})();
